export const aciTalk = {
    iconName: 'talk',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: [
            {
                attr: {
                    d: 'M11.4 17.4a1.2 1.2 0 01-1.2-1.2v-6A1.2 1.2 0 0111.4 9h8.4a1.2 1.2 0 011.2 1.2v6a1.2 1.2 0 01-1.2 1.2h-1.2V21L15 17.4h-3.6z',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M7.8 12.6L5.4 15v-3.6H4.2A1.2 1.2 0 013 10.2v-6A1.2 1.2 0 014.2 3h8.4a1.2 1.2 0 011.2 1.2v2.4',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
        ],
    },
};
